<template>
  <el-dialog
    :visible.sync="showDialog"
    custom-class="card"
    @open="doOpen"
    @closed="doClosed"
    append-to-body
  >
    <template v-if="showContent">
      <div class="icon-lock">
        <img src="./../../../assets/images/img-mail.png" alt>
      </div>
      <div class="dialog-title">
        <h5>绑定邮箱</h5>
        <p>请通过验证码确认您的邮箱</p>
      </div>
      <el-form :model="formData" :rules="rules" ref="formEmail" class="dialog-form">
        <div>
          <el-form-item prop="mail">
            <el-input v-model="formData.mail" placeholder="新邮箱" maxlength="50" clearable></el-input>
          </el-form-item>
          <el-form-item class="pr" prop="code">
            <el-input v-model="formData.code" placeholder="验证码" maxlength="6"></el-input>
            <v-code
              class="vcode"
              session-name="TIME_MAIL_UPDATE"
              action-path="/user-server/setting/sendEmail"
              :vDisabled="isDisabled"
              :action-data="actionData"
            ></v-code>
          </el-form-item>
        </div>
        <div class="gap"></div>
        <transition name="magic">
          <p v-if="showTips">验证码已发送，10分钟有效</p>
        </transition>
      </el-form>
      <div class="btn-box">
        <button class="btn btn-cancel" @click="showDialog = false;">取消</button>
        <button class="btn btn-save" @click="handleUpdate">绑定</button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import vCode from './vCode'
import { mapState } from 'vuex'
import aes from '@/uitls/aes'

export default {
  components: {
    vCode
  },
  computed: {
    ...mapState(['userInfo', 'unlockData']),
    actionData: function() {
      return {
        unlockCode: this.unlockData.code,
        unlockPhone: this.userInfo.phoneNo,
        email: this.formData.mail
      }
    },
    // dialog show/hide
    showDialog: {
      // getter
      get: function() {
        return this.visible
      },
      // setter
      set: function(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    const checkEmail = (rule, value, callback) => {
      const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!reg.test(value)) {
        this.isDisabled = false
        callback(new Error('请输入正确的邮箱地址'))
      } else {
        this.isDisabled = true
        callback()
      }
    }
    return {
      isDisabled: false,
      formData: {
        mail: '',
        code: ''
      },
      rules: {
        mail: [{ validator: checkEmail, trigger: 'blur' }],
        code: [
          { required: true, message: '请输验证码', trigger: 'blur' },
          { min: 6, max: 6, message: '验证码长度为6个字符', trigger: 'blur' }
        ]
      },
      showTips: false,
      // test flight - showContent: false
      showContent: true
    }
  },
  methods: {
    doClosed() {
      this.showContent = false
      this.showTips = false
    },
    doOpen() {
      this.showContent = true
      this.formData.mail = ''
      this.formData.code = ''
    },
    handleSend() {
      this.showTips = true
      this.formData.code = ''
    },
    // update(link) mail by {unlock code, unlock phone}, {mail code, mail address}
    handleUpdate() {
      this.$refs.formEmail.validate(valid => {
        if (valid) {
          this.$http
            .post('/user-server/setting/change/email', {
              // testflight
              unlockPhone: this.userInfo.phoneNo,
              unlockCode: this.unlockData.code,
              email: this.formData.mail,
              emailCode: this.formData.code
            })
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success(res.data.message)
                this.doUpdate()
              } else {
                this.$message.error(res.data.message)
              }
            })
            .catch(err => {
              console.log('ERROR', err)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    doUpdate() {
      this.$emit('update')
      this.showDialog = false
    }
  },
  watch: {
    'formData.code'() {
      let reg = /[^0-9]+/g
      let str = this.formData.code
      reg.test(str) && (this.formData.code = str.replace(reg, ''))
    }
  },
  mounted: function() {}
}
</script>

<style lang="scss" scoped>
@import '../styles/card.scss';
</style>
<style lang="scss">
/* overwrite el-dialog */
.card {
  &.el-dialog {
    width: 440px;
    border-radius: 6px;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 20px;
  }
  .el-form-item {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userInfo/components/cardE.vue